// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import iView from 'iview'
import ElementUI from 'element-ui';
import '../static/style.less'
import 'babel-polyfill'
import ElementDataset from 'element-dataset'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
ElementDataset()
Vue.config.productionTip = false
Vue.use(VueResource);
Vue.use(iView);
Vue.use(ElementUI);

Vue.use(Viewer);
Viewer.setDefaults({
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js